import React from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import icon1 from "../../images/1.0 Homepage/MonitorAgent/icon-1.svg";
import ButtonSolid from "../Button/ButtonSolid";
import { useStaticQuery, graphql, Link } from "gatsby";

const MonitorAgentPerformance = ({ headingLevel, className }) => {
  const data = useStaticQuery(graphql`
    {
      icon1: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-1.svg" }
      ) {
        publicURL
      }
      icon2: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-2.svg" }
      ) {
        publicURL
      }
      icon3: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-3.svg" }
      ) {
        publicURL
      }
      icon4: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-4.svg" }
      ) {
        publicURL
      }
      icon5: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-5.svg" }
      ) {
        publicURL
      }
      icon6: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-6.svg" }
      ) {
        publicURL
      }
      icon7: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/icon-7.svg" }
      ) {
        publicURL
      }
      monitorGraphic1: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-1.svg" }
      ) {
        publicURL
      }
      monitorGraphic2: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-2.svg" }
      ) {
        publicURL
      }
      monitorGraphic3: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-3.svg" }
      ) {
        publicURL
      }
      monitorGraphic4: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-4.svg" }
      ) {
        publicURL
      }
      monitorGraphic4Mobile: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-4-mobile.png" }
      ) {
        publicURL
      }
      monitorGraphic5: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-5.png" }
      ) {
        publicURL
      }
      monitorGraphic6: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/dashboard-6.svg" }
      ) {
        publicURL
      }
      arrowIcon: file(
        relativePath: { eq: "1.0 Homepage/MonitorAgent/arrow-icon.svg" }
      ) {
        publicURL
      }
    }
  `);
  const cards = [
    {
      title: "Dial Attemps",
      image: data.monitorGraphic1.publicURL,
    },
    {
      title: "Call Time",
      image: data.monitorGraphic2.publicURL,
    },
    {
      title: "Contacts",
      image: data.monitorGraphic3.publicURL,
    },
    {
      title: "Appointments Set",
      image: data.monitorGraphic4.publicURL,
    },
    {
      title: "Appointments Set - Mobile",
      image: data.monitorGraphic4Mobile.publicURL,
    },
  ];
  const HeadingTag = headingLevel || "h2";

  return (
    <section className={`${className || "mb-20 md:mb-32"}`}>
      <div className="container mx-auto max-w-[1267px]">
        <div className="flex flex-col items-center justify-center gap-y-16">
          <div className="flex w-full flex-col items-start justify-start">
            <HeadingTag>Monitor Agent Performance</HeadingTag>
            <p>
              We’ve designed the best software to help you see who is performing
              and who is not. Realsynch automatically pulls in each agent’s:
            </p>
          </div>
          <div className="flex flex-col gap-y-6">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
              {cards.slice(0, 3).map((card, index) => (
                <div className="h-full w-full" key={index}>
                  <img
                    src={card.image}
                    className="h-full w-full object-contain"
                    width={300}
                    height={251}
                  />
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 gap-x-2 gap-y-6 lg:grid  lg:grid-cols-[1fr_auto] lg:justify-between">
              <img
                src={cards[3].image}
                className="hidden h-full w-full object-contain lg:flex"
                width={932}
                height={267}
              />
              <img
                src={cards[4].image}
                className="h-full w-full max-w-[418px] object-contain lg:hidden"
                width={300}
                height={251}
              />
              <Link
                to="/product/business-intelligence/"
                className="flex h-full w-full flex-col items-center rounded-[16px] border-[1px] border-purple-600 py-6 px-4"
              >
                {/* <img
                  src={cards[5].image}
                  className="h-full w-full object-contain "
                  width={300}
                  height={267}
                /> */}
                <img
                  src="/images/dashboard-6.svg"
                  className="h-full w-full max-w-[181px] object-contain"
                  width={181}
                  height={138}
                />
                <div className="flex w-full items-center justify-center gap-x-2  text-button-primary ">
                  <div
                    className="text"
                    style={{ textDecorationColor: "transparent !important" }}
                  >
                    Explore Features
                  </div>
                  <img
                    src={data.arrowIcon.publicURL}
                    className="h-4 w-4 object-contain"
                    width={16}
                    height={16}
                  />
                </div>
              </Link>
            </div>
          </div>

          <ButtonSolid
            href="/free-trial"
            text="Start Free Trial"
            altStyle={2}
            className="mx-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default MonitorAgentPerformance;
